import { useEffect } from 'react'

import useAppSelector from '@/hooks/useAppSelector'
import { useCaptureErrorShownToUserEvent } from '@/hooks/useCaptureErrorShownToUserEvent'
import { selectSessionMetadata } from '@/redux/slices/session'

export function useCaptureErrorAfterTwoSeconds(error: unknown) {
  const sessionMetadata = useAppSelector(selectSessionMetadata)
  const captureErrorShownToUserEvent = useCaptureErrorShownToUserEvent()

  useEffect(() => {
    // Sometimes <UnhandledErrorMessage /> may render for a split second before
    // the user is taken to another route (e.g., when a session expires).
    // In such cases, we don't want to capture the error so let's wait for 2
    // seconds before capturing the error.
    const captureErrorEventTimer = setTimeout(
      () => captureErrorShownToUserEvent(error),
      2000,
    )

    // Clear the timer if the component unmounts
    return () => {
      clearTimeout(captureErrorEventTimer)
    }
  }, [captureErrorShownToUserEvent, error, sessionMetadata])
}
